import {Divider} from '@mantine/core';
import {useRouter} from 'next/router';
import {type FC, useState} from 'react';
import {MdClose} from 'react-icons/md';
import {useGetResultByBuilderId} from '../../../../core/repositories/entrySheetBuilderRepository';
import {NOT_SHOW_ADD_TO_PROFILE_MODAL_BUTTON_OPTION_ID} from '../../constants';
import {SelectedTheme} from './Presenter/SelectedTheme';
import {GeneratedSystemMessage} from './Presenter/SystemMessage';

export const TmpResult: FC<{
  options: Array<{
    id: number;
    choice: string;
  }>;
  isValid: boolean;
}> = ({options, isValid}) => {
  const router = useRouter();

  // /engineer/ai-es-builder/:id
  const {id} = router.query as {id: string};
  const {data: resultData} = useGetResultByBuilderId({builderId: id});
  const [tmpResultDisplay, setTmpResultDisplay] = useState(id !== undefined);
  const handleCloseTmpResult = () => {
    setTmpResultDisplay(false);
  };

  return (
    <>
      {resultData?.ok && tmpResultDisplay && (
        <div>
          <div className="flex justify-end p-8">
            <MdClose
              size={24}
              className="cursor-pointer"
              onClick={handleCloseTmpResult}
            />
          </div>
          <SelectedTheme
            themeId={resultData.value.entrysheetThemeId}
            options={options ?? []}
          />
          <GeneratedSystemMessage
            isValid={isValid}
            isModeration={resultData.value.entrysheetBuilderId !== ''}
            themeId={resultData.value.entrysheetThemeId}
            message={resultData.value.result}
            isShowAddToProfileButton={
              resultData.value.entrysheetThemeId !==
              NOT_SHOW_ADD_TO_PROFILE_MODAL_BUTTON_OPTION_ID
            }
            isOpenModal={false}
          />
          <Divider className="mt-32" />
        </div>
      )}
    </>
  );
};
